import { Box, Grid } from '@mui/material'
import React from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import useBookingRecaption from '../../../components/BookingRecaption/hook/useBookingRecaption'
import { useState } from 'react'
import useAxios from '../../../hooks/useAxios'
import BookingRecaption from '../../../components/BookingRecaption/BookingRecaption'
import { routes } from '../../../utils/constants'
import { CloseButton, SaveButton } from '../ClientMmDetails/ClientMmDetails.style'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handelNotifications } from '../../../redux/slices/Notification/notificationSlice'

const TraderDetails = ({ traderId }) => {
  const [search, setSearch] = useState({ search: '' })
  const request1 = {
    endPoint: routes.contractDistribution,
    params: search
  }
  const request2 = {
    endPoint: routes.trader.concat(`/${traderId}`)
  }
  const { response: contractDistribution, setResponse: setResponseContractDistribution } =
    useAxios(request1)
  const token = useSelector(state => state.auth.token)
  const { response: trader } = useAxios(request2)
  const [form, setForm] = useState({ id: traderId, emails: [] })
  const [initialForm, setInitialForm] = useState({ id: traderId, emails: [] })
  const dispatch = useDispatch()
  const { submitNewContract, handelEmail } = useBookingRecaption({
    setSearchEmail: setSearch,
    searchEmail: search,
    form,
    setForm,
    contractDistribution,
    setResponseContractDistribution
  })

  useEffect(() => {
    if (trader.status === 200) {
      setForm({ id: traderId, emails: trader.data.mailing_list })
      setInitialForm({ id: traderId, emails: trader.data.mailing_list })
    }
  }, [trader])

  const handelBookingRecaption = event => {
    const { value, checked } = event.target
    const copyForm = JSON.parse(JSON.stringify(form))
    if (checked) {
      copyForm.emails.push(value)
    } else if (!checked) {
      const elementIndex = copyForm.emails.indexOf(value)
      copyForm.emails.splice(elementIndex, 1)
    }
    setForm(copyForm)
  }

  const disable = () => {
    return form.emails.every(email => initialForm.emails.includes(email))
  }

  const handleDiscardChange = () => {
    setForm(initialForm)
  }

  const handleSubmit = async () => {
    const url = process.env.REACT_APP_SERVER_URL.concat(routes.trader)
    try {
      await axios.put(url, form, { headers: { Authorization: token } })
      dispatch(
        handelNotifications({
          id: Date.now(),
          type: 'success',
          message: 'trader update successfully'
        })
      )
    } catch (error) {
      dispatch(
        handelNotifications({
          id: Date.now(),
          type: 'error',
          message: 'sorry something wrong happen'
        })
      )
    }
  }
  return (
    <Grid container>
      {Array.isArray(contractDistribution.data) && (
        <Grid item xs={4} style={{ display: 'flex', flexDirection: 'column' }}>
          <BookingRecaption
            form={form}
            searchEmail={search}
            handelEmail={handelEmail}
            handelFormChange={handelBookingRecaption}
            contractDistribution={contractDistribution}
            contractDistributionTitle={'Mailing List'}
            submitNewContract={submitNewContract}
            style={{ background: '#242428', maxHeight: '300px', height: '290px' }}
            backgroundSearchBarContainer={'#242428'}
            backgroundSearchBar="#39393C"
            pageArea={'Entity'}
          />
          <Box style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px' }}>
            <CloseButton onClick={handleDiscardChange} disabled={disable()}>
              Discard Changes
            </CloseButton>
            <SaveButton onClick={handleSubmit} disabled={disable()}>
              Save Changes
            </SaveButton>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}

export default TraderDetails

TraderDetails.propTypes = { traderId: PropTypes.number }
